export const isValidEmail = (email: string): boolean => {
  return /^[^@]+@[^@]+\..+$/i.test(email);
};
